import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

// Page Imports
import Welcome from "./pages/Welcome";
import Dashboard from "./pages/Dashboard";
import Lesson from "./pages/Lesson";

// Style Import
import "./index.css"; 

function App() {
  return (
    <Router>
      <Routes>
        {/* The Landing Page */}
        <Route path="/" element={<Welcome />} />
        
        {/* The Main Skill Tree Map */}
        <Route path="/dashboard" element={<Dashboard />} />
        
        {/* The Socratic Lesson Engine (Dynamic ID) */}
        <Route path="/lesson/:id" element={<Lesson />} />

        {/* Catch-all: Redirects any unknown URL back to Welcome */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
